export enum TextContent {
    ADDED = 'added',
    REMOVED = 'removed',
    REMOVED_CAN_REVERT = 'removedcanrevert',
    Full = 'full',
    NOT_AVAILABLE = 'notavailable',
}
